import {
  Box,
  HStack,
  Icon,
  SkeletonCircle,
  SkeletonText,
  Text,
  VStack,
  Center,
  Button,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
  RiBookmarkLine,
  RiCalendarTodoFill,
  RiTimerLine,
  RiTvLine,
  RiPlayFill,
  RiPauseFill,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getVideoByIdRequest } from "../../../modules/students-modules/videos/Actions";
import Player from "../../vdoPlayer/player";
import YouTubeEmbed from "../../../components/YouTubeEmbed";
import VimeoEmbed from "../../../components/VimeoEmbed";

const VideoPreview = ({ data, loading, otp, playBack }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const videoDetails = useSelector((state) => state.chapterVideos.videoDetails);
  const userData = useSelector((state) => state.user.userData);

  const video = data ? data : videoDetails;
  console.log("video", video);
  const videoGroups = video?.groups?.map((val) => val?.id);
  const date1 = dayjs(video?.expiry_date);
  const diff = date1.diff(video?.created_at, "day");
  // const playbackInfo = useSelector((state) => state.chapterVideos.playbackInfo);
  const seenLoading = useSelector((state) => state.chapterVideos.seenLoading);
  const [isPlaying, setIsPlaying] = useState(false);
  const handlePlayPauseToggle = () => {
    const iframe = document.querySelector('iframe[title="YouTube video"]');
    if (iframe) {
      if (isPlaying) {
        // Pause the video
        iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        setIsPlaying(false);
      } else {
        // Play the video
        iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        setIsPlaying(true);
      }
    }
  };
  useEffect(() => {
    if (!data) dispatch(getVideoByIdRequest(id));
  }, [data]);

  return (
    <VStack
      bg="main_1"
      borderRadius="8px"
      p="20px"
      color="white"
      w="75%"
      h="100%"
      alignItems="flex-start"
      spacing="15px"
      position="relative"
      alignSelf="center"
    >
      {/* title */}
      <Text fontSize="28px" fontWeight="500">
        {video?.title}
      </Text>

      {/* video */}
      <Box
        bg="gray"
        w="100%"
        h="100%"
        alignSelf="center"
        borderRadius="8px"
      >
        {video?.views_count && video?.views_count?.views_count == 3 ? (
          <Text textAlign="center" p={4} fontSize="20px">
            Contact the technical support
          </Text>
        ) : video?.views_count && video?.views_count?.views_count == 4 ? (
          <Text textAlign="center" p={4} fontSize="20px">
            You have exceeded the allowed watch duration. You can request a voucher and contact your assistant.
          </Text>
        ) : video?.suspended == 1 && video?.user_video_suspended != 0 ? (
          <>
            {video?.related_to_homework == 1 && video?.exams?.length != 0 ? (
              <Text textAlign="center" p={4} fontSize="20px">
                Video Locked please submit hw or solve the exam {video?.exams[0]?.name}
              </Text>
            ) : video?.related_to_homework == 1 && video?.exams?.length == 0 ? (
              <Text textAlign="center" p={4} fontSize="20px">
                Video Locked please submit hw
              </Text>
            ) : video?.related_to_homework == 0 && video?.exams?.length != 0 ? (
              <Text textAlign="center" p={4} fontSize="20px">
                Video Locked please solve the exam {video?.exams[0]?.name}
              </Text>
            ) : (
              <Text textAlign="center" p={4} fontSize="20px">
                Video Locked request voucher and contact the assistant
              </Text>
            )}
          </>
        ) : !videoGroups?.includes(userData?.group?.id) ? (
          <Text textAlign="center" p={4} fontSize="20px">
            Not available to your group or choose a video from Playlist
          </Text>
        ) : video?.video_type != 1 && video?.video_type != 3 ? (
          <YouTubeEmbed 
            videoUrl={video?.url} 
            videoType={video?.video_type}
          />
        ) : video?.video_type == 3 ? (
          <VimeoEmbed videoUrl={video?.url} data={video} />
        ) : loading ? null : (
          <Player otp={otp} playbackInfo={playBack} data={data} />
        )}
      </Box>

      {/* options */}
      {seenLoading ? (
        <HStack w="100%" bg="transparent">
          <SkeletonCircle size="6" startColor="gray.100" endColor="gray.600" />
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={1}
            spacing="4"
          />
        </HStack>
      ) : (
        <HStack
          justifyContent="space-between"
          w="100%"
          fontSize={{ base: "10px", lg: "18px" }}
        >
          <HStack spacing={{ base: "5px", lg: "50px" }}>
            <HStack spacing="8px" w="100%">
              <Icon as={RiCalendarTodoFill} />
              <Text w="fit-content">
                {dayjs(video?.created_at).format("D , MMM ,YYYY")}
              </Text>
            </HStack>
            {diff && userData?.subject?.id != "34" && (
              <HStack spacing="8px" w="100%">
                <Icon as={RiTimerLine} />
                <Text w="fit-content">{diff} Days remaining</Text>
              </HStack>
            )}
            {video?.views_count && userData?.subject?.id != "34" && (
              <HStack spacing="8px" w="100%">
                <Icon as={RiTvLine} />
                <Text w="fit-content">{`Watch ${video?.max_allowed_views -
                  (video?.views_count?.views_count > video?.max_allowed_views
                    ? video?.max_allowed_views
                    : video?.views_count?.views_count) || 0
                  } more times (${video?.views_count?.views_count
                    ? video?.views_count?.views_count > video?.max_allowed_views
                      ? video?.max_allowed_views
                      : video?.views_count?.views_count
                    : 0
                  }/${video?.max_allowed_views ? video?.max_allowed_views : 0
                  })`}</Text>
              </HStack>
            )}
          </HStack>
          {video?.video_type == 0 && (
          <HStack>
          <Button
          onClick={handlePlayPauseToggle}
          >
            <Icon
            as={isPlaying ? RiPauseFill : RiPlayFill}
            display={{ base: "none", lg: "block" }}
            cursor="pointer"
            _hover={{ transform: "scale(1.1)" }}
            transition="transform 0.2s ease-in-out"
            color="black"
          />
          <Text color="black">Play/Pause</Text> 
          </Button>
          </HStack>
        )}
        </HStack>
      )}
      <HStack> <Icon as={RiTvLine} />
        <Text>
          {`${video?.over_view}`}
        </Text>
      </HStack>
    </VStack>
  );
};

export default VideoPreview;
